import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class HttpClearParamsInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        let keys = req.params.keys();
        let params = {};
        for(let i in keys){
            let val = req.params.get(keys[i]);
            if ((val !== null) && (val !== undefined) && (val !== 'null') && (val !== 'undefined')) {
                params[keys[i]] = val;
            }
        }

        const request = req.clone({ 
            params: new HttpParams({fromObject: params}) ,
        });
        return next.handle(request);  
    }
}
